/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Sync_OkInputs */

const cs_portals_sync_ok = /** @type {(inputs: Portals_Sync_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuální`)
};

const en_portals_sync_ok = /** @type {(inputs: Portals_Sync_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to date`)
};

/**
* | output |
* | --- |
* | "Up to date" |
*
* @param {Portals_Sync_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_sync_ok = /** @type {((inputs?: Portals_Sync_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Sync_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_sync_ok(inputs)
	return cs_portals_sync_ok(inputs)
});